import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { 
    UpdateLocationMutationMutation,
    UpdateLocationMutationMutationVariables 
} from "../../../schemaTypes";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../utils/normalizeErrors";

export const updateLocationMutation = gql`
  mutation UpdateLocationMutation(
    $locationId: String!
    $input: UpdateLocationInput!
  ) {
    updateLocation(
      locationId: $locationId
      input: $input
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitUpdateLocation: (
        values: UpdateLocationMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      updateLocationData: any | null; 
    }
  ) => ReactElement | null;
}

export const UpdateLocationController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    UpdateLocationMutationMutation,
    UpdateLocationMutationMutationVariables
  >(updateLocationMutation);

  const submitUpdateLocation = async (values: UpdateLocationMutationMutationVariables) => {
    const { data: {updateLocation} }:any = await mutate({ variables: values });

    if (updateLocation?.errors) {
      return {error: normalizeErrors(updateLocation.errors), updateLocation: null};
    }

    return {
      error: null,
      updateLocation
    };
  };

  const message = data?.updateLocation?.message || null;

  return children({
    submitUpdateLocation,
    loading,
    error,
    message,
    updateLocationData: data,
  });
};